import * as React from 'react'

import {ToastProvider} from '@vio/atlas/context/toastController'
import {PageWidthContainer} from '@vio/atlas/helpers/PageWidthContainer'

type PageWidthContainerPropsType = {
  children: React.ReactNode
  className?: string
}

const PageWidthContainerBookingManagement = ({
  children,
  className
}: PageWidthContainerPropsType) => (
  <PageWidthContainer className={className} maxPageWidth={1120}>
    <ToastProvider>{children}</ToastProvider>
  </PageWidthContainer>
)

export default PageWidthContainerBookingManagement
